import { apartmentInfo, contactInfo } from "../config/siteData";
import { useLanguage } from "../context/LanguageContext";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  const quickLinks = [
    { href: "#galerija", label: t.nav.gallery },
    { href: "#opis", label: t.nav.about },
    { href: "#lokacija", label: t.nav.location },
    { href: "#faq", label: t.nav.faq },
    { href: "#upit", label: t.inquiry.subtitle },
  ];

  return (
    <footer
      className="bg-[#0F172A] text-white py-12"
      data-testid="footer"
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold font-['Outfit'] mb-4">
              {apartmentInfo.name}
            </h3>
            <p className="text-white/70 text-sm leading-relaxed">
              {t.hero.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold font-['Outfit'] mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2 text-sm">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/70 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold font-['Outfit'] mb-4">{t.footer.contact}</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <a href={`tel:${contactInfo.phone}`} className="hover:text-white transition-colors duration-200">
                  {contactInfo.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${contactInfo.email}`} className="hover:text-white transition-colors duration-200">
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/50">
              © {currentYear} {apartmentInfo.name}. {t.footer.rights}
            </p>
            <p className="text-xs text-white/30">
              {t.footer.privacy}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
